import colorStyles from '../../constants/user-color-constants/index.json';

const CircularPill = ({
  size = 24,
  className = 'body-12-medium',
  color = 'primary-main',
  value = 0,
  renderDirect = false,
  ...props
}) => {
  const styles = {
    minWidth: `${size}px`,
    height: `${size}px`,
    borderRadius: `${size}px`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingInline: '7px',
    ...colorStyles[color],
  };

  return (
    <div style={styles} className={className} {...props}>
      {renderDirect ? value : String(value).padStart(2, '0')}
    </div>
  );
};

export default CircularPill;
